<template>
  <div class="joinEx">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "joinEx", // 参展申请
  data() {
    return {

    };
  },
  components: {
  },
  computed: {

  },
  methods: {
    ...mapActions({

    }),
  },
  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.$router.push(`/basic/mobile`);
    }
  },
};
</script>

<style scoped lang='scss'></style>